import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Input, Dropdown } from 'semantic-ui-react';
import i18next from 'i18next';
import api from '../../actions/api';

class ImageInputComponent extends Component {
    state = { mode: this.props.resizeMode ? 'contain' : null };

    handleFileUpload = ({ target }) => {
        if (target && target.files[0]) {
            const file = target.files[0];
            this.props.handleFileUpload(file, this.state.mode);
        }
    }

    renderDropdown = () => {
        if (this.props.resizeMode) {
            return (
                <Dropdown
                    fluid
                    style={{ marginTop: 5 }}
                    value={this.state.mode}
                    onChange={(e, { value }) => value ? this.setState({ mode: value }) : this.props.unsetImage()}
                    options={[{ text: 'contain', value: 'contain' }, { text: 'cover', value: 'cover' }, { text: 'remove', value: '' }]}
                />
            );
        }
        return null;
    }

    render() {
        const { commonImages } = this.props;

        return (
            <div>
                <Input
                    fluid
                    label={{ basic: true, image: this.props.imageUrl, content: this.renderDropdown() }}
                    labelPosition='right'
                    type="file"
                    onChange={this.handleFileUpload}
                />
                {this.props.handleCommonSelection && !!commonImages.length &&
                    <Dropdown
                        fluid
                        placeholder="Pick from common images"
                        selection
                        search
                        // value={this.state.mode}
                        onChange={(e, { value }) => this.props.handleCommonSelection(value)}
                        options={[null].concat(commonImages).map(value => ({ value, text: value ? value.split('/')[1] : '' }))}
                    />
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { commonImages } = state.meta;

    return { commonImages };
};

const ImageInput = connect(mapStateToProps)(ImageInputComponent);

export { ImageInput };
